import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['video', 'bar'];

  connect() {
    this.videoTarget.addEventListener('play', this.__start);
    this.videoTarget.addEventListener('pause', this.__stop);
    this.videoTarget.addEventListener('ended', this.__stop);
    this.videoTarget.addEventListener('seeked', this.__updateBar);
    this.videoTarget.addEventListener('loadedmetadata', this.__updateBar);
    this.__updateBar();
    if (!this.videoTarget.paused) this.__start();
  }

  disconnect() {
    this.__stop();
    this.videoTarget.removeEventListener('play', this.__start);
    this.videoTarget.removeEventListener('pause', this.__stop);
    this.videoTarget.removeEventListener('ended', this.__stop);
    this.videoTarget.removeEventListener('seeked', this.__updateBar);
    this.videoTarget.removeEventListener('loadedmetadata', this.__updateBar);
  }

  // Update per animation frame while playing so the bar advances smoothly,
  // rather than stepping on the ~4x/sec `timeupdate` event.
  __start = () => {
    if (this.__raf) return;
    const tick = () => {
      this.__updateBar();
      this.__raf = requestAnimationFrame(tick);
    };
    this.__raf = requestAnimationFrame(tick);
  };

  __stop = () => {
    if (this.__raf) cancelAnimationFrame(this.__raf);
    this.__raf = null;
    this.__updateBar();
  };

  __updateBar = () => {
    const { currentTime, duration } = this.videoTarget;
    if (!duration || !isFinite(duration)) return;
    const ratio = Math.min(1, Math.max(0, currentTime / duration));
    this.barTarget.style.transform = `scaleX(${ratio})`;
  };
}
